export function FormatLocaleDate(date: string) {
  if (!date) return null

  const parsedDate = new Date(date)

  const formatter = new Intl.DateTimeFormat('en-IE', {
    dateStyle: 'short',
    timeZone: 'UTC',
  })

  const formattedDate = formatter.format(parsedDate)

  return formattedDate
}

export function FormatLocaleDateWithHoursAndSeconds(date: string) {
  if (!date) return null

  const parsedDate = new Date(date)

  const formatter = new Intl.DateTimeFormat('en-IE', {
    dateStyle: 'short',
    timeStyle: 'medium',
  })

  const formattedDate = formatter.format(parsedDate)

  return formattedDate
}

export function FormatLocaleDateWithMonthAndYear(date: string) {
  if (!date) return ''

  const parsedDate = new Date(date)

  const formatter = new Intl.DateTimeFormat('en-IE', {
    month: 'short',
    year: 'numeric',
  })

  const formattedDate = formatter
    .format(parsedDate)
    .replace('.', '')
    .replace(' de ', '/')
    .replace(' ', '/')
    .replace(/^./, (c) => c.toUpperCase())

  return formattedDate
}
